// Custos Gerais por Projeto (Gestão Orçamentária): mesmas categorias de Custos Gerais
// (OPERAÇÃO), reorganizadas por projeto. Viagens e Softwares não são mais seções à parte —
// viram só um `tipo_lancamento` de item dentro da árvore de categorias.
// Espelha backend/config.py ROLES_CUSTOS_GERAIS_PROJETO — mantenha os dois em sincronia.
export const ROLES_CUSTOS_GERAIS_PROJETO = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO", "OPERACAO", "ASSISTENTEOPERACAO"];

// Únicas categorias com tipos de lançamento além de "valor_manual" — espelha
// backend/services/custos_gerais_projeto_svc.py _tipos_permitidos, mantenha em sincronia.
export const CODIGO_CATEGORIA_VIAGENS_PREFIXO = "2.5";
export const CODIGO_CATEGORIA_ASSINATURAS = "2.6.11";

export const TIPOS_LANCAMENTO_OPTIONS = [
  { value: "valor_manual", label: "Valor bruto (manual)", descricao: "Só o valor, digitado direto — ex: uma assinatura fixa." },
  { value: "alocacao_projeto", label: "Alocação por Projeto", descricao: "Ticket por pessoa × headcount alocado a este projeto no mês (Σ % de Alocação de Pessoal ÷ 100). Ex.: 2 pessoas a 50% = 1 pessoa equivalente." },
  { value: "quantidade_usuarios", label: "Quantidade de usuários", descricao: "Valor unitário × nº de usuários, preenchido manualmente." },
  { value: "viagem", label: "Viagem", descricao: "Ticket médio × nº viagens × nº pessoas × (1 + reajuste)." },
];

// tipos permitidos por categoria — mesma regra do backend: valor_manual sempre vale; os
// demais só em 2.5 Despesas de Viagens (+ viagem, exclusivo dela) ou 2.6.11 Assinaturas e
// Sistemas.
export function tiposPermitidosParaCategoria(categoria) {
  if (!categoria) return ["valor_manual"];
  if (categoria.codigo === CODIGO_CATEGORIA_ASSINATURAS) return ["valor_manual", "alocacao_projeto", "quantidade_usuarios"];
  if (categoria.codigo === CODIGO_CATEGORIA_VIAGENS_PREFIXO || categoria.codigo.startsWith(`${CODIGO_CATEGORIA_VIAGENS_PREFIXO}.`)) {
    return ["valor_manual", "alocacao_projeto", "quantidade_usuarios", "viagem"];
  }
  return ["valor_manual"];
}

export function categoriaEhEspecial(categoria) {
  return tiposPermitidosParaCategoria(categoria).length > 1;
}
